export const CHART_HEIGHT = 210;

export enum YAxisOrientations {
  LEFT = 'left',
  RIGHT = 'right',
}
